export default __webpack_public_path__ + "static/media/ava5.e2762e79.png";